import React from 'react';
import MainLayout from '../../../shared/ui/layout/MainLayout';
import PcfValidationContent from './PcfValidationContent';

interface PcfValidationPageProps {
  onGoBack?: () => void;
}

const PcfValidationPage: React.FC<PcfValidationPageProps> = ({ onGoBack }) => {
  return (
    <MainLayout
      title="PCF validation"
      windowVariant="workspace"
      hideUtilityChrome={true}
      disableContentScroll={true}
      workflowChromeVariant="workspace"
    >
      <PcfValidationContent onGoBack={onGoBack} />
    </MainLayout>
  );
};

export default PcfValidationPage;
